import { render, staticRenderFns } from "./examPaperPreView.vue?vue&type=template&id=044e9d8e&scoped=true&"
import script from "./examPaperPreView.vue?vue&type=script&lang=js&"
export * from "./examPaperPreView.vue?vue&type=script&lang=js&"
import style0 from "./examPaperPreView.vue?vue&type=style&index=0&id=044e9d8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044e9d8e",
  null
  
)

export default component.exports